import { Injectable } from '@angular/core';
import { formatTimestamp, getDateTimeText } from '@app/modules/shared/utilities/utilities';
import { GetLocaleService } from './get-locale.service';
import { EnvironmentService } from './environment.service';
import { DISTANCE_UNITS } from '@environments/shared.models';
import { SettingsFacade } from '@app/modules/settings/facade/settings.facade';
import { Settings } from '@app/store/settings/reducers/settings.reducer';
import { UiUtilities } from './ui-utilities';
import { AppConfigService } from './app-config/app-config.service';
import { PathDistanceUnits } from '@app/modules/location/models/path-api.model';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  constructor(
    private getLocaleService: GetLocaleService,
    private envService: EnvironmentService,
    private settingsFacade: SettingsFacade,
    private uiUtils: UiUtilities,
    private appConfigService: AppConfigService
  ) {
    this.settingsFacade.getDisplaySettings().subscribe((settings: Settings) => {
      this.userSettings = settings;
    });
  }

  private browserLocale = this.getLocaleService.browserLocale;
  private l10n = 'l10n';
  private opts = {
    date: false,
    seconds: false
  };
  userSettings: Settings;

  // @param timeStamp: string i.e. 2021-07-20T13:41:33
  // @param opts: { seconds: boolean, date: boolean } , whether to include seconds or date in the returned output, defaults to false
  getLocalizedTime(timestamp: string, opts = this.opts) {
    let timeFormat: string = this.envService.getEnvironmentProperty(this.l10n)[this.browserLocale].timeFormat;
    let dateFormat: string = null;
    let { timeZone } = this.appConfigService.getConfig();
    timeZone = timeZone || this.appConfigService.getLocalTimeZone();

    if (opts.date) {
      const { dateFormat: dtFormat } = this.userSettings;
      dateFormat = this.uiUtils.convertLuxonToMomentFormat(dtFormat);
    }

    if (opts.seconds) {
      timeFormat = this.envService.getEnvironmentProperty(this.l10n)[this.browserLocale].timeFormatWithSeconds;
    }

    return dateFormat !== null
      ? getDateTimeText(timestamp, `${dateFormat} ${timeFormat}`, timeZone)
      : formatTimestamp(timestamp, timeFormat, timeZone);
  }

  setLocalizedNumberFormat(number: number) {
    return new Intl.NumberFormat(this.browserLocale).format(number);
  }

  getUseMetricDistance() {
    return this.userSettings.distanceUnit == PathDistanceUnits.KM; // returns true if kms (metric)
  }

  getMapTileLanguage() {
    return this.envService.getEnvironmentProperty(this.l10n)[this.browserLocale].mapTileLg;
  }
}
